(() => {
  function initializeStories() {
    const section = document.querySelector('[data-sovra-stories]');
    if (!section || section.dataset.ready === 'true') return;
    const wrapper = section.closest('.shopify-section');
    const anchor = section.dataset.page === 'index'
      ? document.getElementById('sv-home-ending')
      : document.querySelector('#MainContent [id$="__main"]');
    if (wrapper && anchor && !wrapper.contains(anchor)) {
      if (section.dataset.page === 'index') anchor.before(wrapper);
      else anchor.after(wrapper);
    }
    section.dataset.ready = 'true';
    if (location.hash === '#sv-customer-stories' || location.hash === '#sv-stories-heading') {
      section.scrollIntoView({ block: 'start', behavior: 'instant' });
    }
    const list = section.querySelector('.sv-stories__list');
    const navigation = section.querySelector('[data-stories-navigation]');
    const previous = section.querySelector('[data-stories-direction="-1"]');
    const next = section.querySelector('[data-stories-direction="1"]');
    const controller = new AbortController();
    const options = { signal: controller.signal };
    function update() {
      const overflow = list.scrollWidth > list.clientWidth + 2;
      navigation.hidden = !overflow;
      previous.disabled = list.scrollLeft <= 2;
      next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
    }
    for (const button of [previous, next]) {
      button.addEventListener('click', () => {
        const card = list.querySelector('.sv-stories__card');
        const distance = card.getBoundingClientRect().width + 16;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        list.scrollBy({ left: distance * Number(button.dataset.storiesDirection), behavior });
      }, options);
    }
    list.addEventListener('scroll', update, { ...options, passive: true });
    const observer = new ResizeObserver(update);
    observer.observe(list);
    update();
    document.addEventListener('shopify:section:unload', event => {
      if (event.target === wrapper || event.target.contains(section)) {
        observer.disconnect();
        controller.abort();
      }
    }, options);
    document.addEventListener('shopify:block:select', event => {
      if (!list.contains(event.target)) return;
      const card = event.target.closest('.sv-stories__card');
      if (!card) return;
      list.scrollTo({ left: card.offsetLeft - list.offsetLeft - 24, behavior: 'instant' });
    }, options);
  }
  if (!window.sovraStoriesInitialized) {
    window.sovraStoriesInitialized = true;
    document.addEventListener('shopify:section:load', initializeStories);
  }
  initializeStories();
})();
